import React, { useState,useEffect } from 'react'
import './index.less'
import { Icon } from 'antd'

export interface AppSearchInputProps {
	value?: string
	placeholder?: string
	onSearch?: (value: string) => void
	onChange?: (value: string) => void
}

export const AppSearchInput = (props: AppSearchInputProps) => {

	const [state, setState] = useState('default')
	const [value,setValue] = useState(props.value||'')

	const onChange = () => {
		if(refInput.current.value !== value){
			setValue(refInput.current.value);
			props.onChange && props.onChange(refInput.current.value);
		}
		setState('default')
	}

	const onSearch = () => {
		props.onSearch && props.onSearch(value)
	}

	useEffect(() => {
		if(props.value !== value){
			setValue(props.value||'');
			refInput.current.value = props.value;
		}
	}, [props.value])

	const refInput = React.createRef<HTMLInputElement>()
	return (
		<span className='app-input-main'>
            <div className='app-input-container' data-state = {state}>
                <div className='app-input-middle'>
                    <input 
                        ref={refInput}
                        placeholder={props.placeholder || ''}
                        defaultValue={props.value||''}
                        onBlur={onChange}
                        onFocus={e =>  setState('active')}
                    />
                </div>
				<div className='app-input-right' style={{cursor:'pointer'}} onClick={onSearch}>
					<span className='app-input-right-icon'><Icon type="search"/> </span>
				</div>
            </div>
        </span>
	)
}




// WEBPACK FOOTER //
// ./src/qcc/AppInput/AppSearchInput.tsx